import React from 'react';
import styled from 'styled-components';
import Reveal from './ui/Reveal';
import CountUp from './ui/CountUp';
import Marquee from './ui/Marquee';
import { useI18n } from '../context/LanguageContext';

const Section = styled.section`
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 2rem 2rem 1rem;
  @media (max-width: 768px) { padding: 1rem 1.25rem; }
`;

const Panel = styled.div`
  border: 1px solid var(--border);
  background: var(--surface);
  border-radius: 24px;
  padding: 2.25rem 2rem;
  backdrop-filter: blur(8px);
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  @media (max-width: 700px) { grid-template-columns: repeat(2, 1fr); gap: 1.5rem; }
`;

const Stat = styled.div`
  text-align: center;
  .num {
    font-family: var(--font-heading);
    font-size: clamp(2.1rem, 5vw, 3rem);
    font-weight: 700;
    line-height: 1;
  }
  .lbl {
    margin-top: 0.5rem;
    font-size: 0.9rem;
    color: var(--text-muted);
  }
`;

const Strip = styled.div`
  margin-top: 2rem;
  padding-top: 1.75rem;
  border-top: 1px solid var(--border);

  .label {
    display: block;
    text-align: center;
    font-size: 0.75rem;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: var(--text-faint);
    margin-bottom: 1rem;
  }
  .name {
    display: inline-flex;
    align-items: center;
    gap: 1.5rem;
    font-family: var(--font-heading);
    font-weight: 600;
    font-size: 1.05rem;
    color: var(--text-muted);
    white-space: nowrap;
    transition: color 0.25s ease;
  }
  .name:hover { color: var(--text); }
  .sep { color: var(--secondary); font-size: 0.8rem; }
`;

const Stats = () => {
  const { t, data } = useI18n();
  const { stats, workedWith } = data;

  return (
  <Section id="impact">
    <Reveal>
      <Panel>
        <Row>
          {stats.map((s) => (
            <Stat key={s.label}>
              <div className="num gradient-text">
                <CountUp value={s.value} suffix={s.suffix} />
              </div>
              <div className="lbl">{s.label}</div>
            </Stat>
          ))}
        </Row>
        <Strip>
          <span className="label">{t.stats.workedWith}</span>
          <Marquee duration={24} gap="1.5rem">
            {workedWith.map((w) => (
              <span className="name" key={w}>{w} <span className="sep">✦</span></span>
            ))}
          </Marquee>
        </Strip>
      </Panel>
    </Reveal>
  </Section>
  );
};

export default Stats;
